const useGeneralAttributesPanel = () => {
  const attributesList = [];
  const isLoading = false;

  return [attributesList, isLoading];
};

export default useGeneralAttributesPanel;
